"use client";

import { useEffect, useRef, useState } from "react";

import { buildImageSrcSet, withImageRenderParams } from "@garimpa/lib/imageUrls";

interface HeroBackgroundImageProps {
  className?: string;
  imageUrl: string;
  priority?: boolean;
}

export function HeroBackgroundImage({ className, imageUrl, priority }: HeroBackgroundImageProps) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const isFailed = failedUrl === imageUrl;

  useEffect(() => {
    if (isFailed) return;

    const image = imageRef.current;
    if (image?.complete && image.naturalWidth === 0) {
      setFailedUrl(imageUrl);
    }
  }, [imageUrl, isFailed]);

  if (isFailed) return null;

  return (
    <img
      key={imageUrl}
      ref={imageRef}
      src={withImageRenderParams(imageUrl, { width: 1280 })}
      srcSet={buildImageSrcSet(imageUrl, [640, 960, 1280, 1600])}
      sizes="100vw"
      alt=""
      aria-hidden="true"
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "low"}
      onError={() => {
        setFailedUrl(imageUrl);
      }}
      className={className}
    />
  );
}
